// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__g7ttP","token":"styles_token__AgZX_"};